// id:42可用
export const serveList = [{
    name: "新游首发",
    icon: "https://bhres.39bh.com/promote_zs_static/new_game.png",
    url: "/home/today_new",
    id: 5,
    show: false
  },
  {
    name: "活动查询",
    icon: "https://bhres.39bh.com/promote_zs_static/active_s.png",
    url: "/home/active_search",
    id: 3,
    show: false
  },
  {
    name: "开服信息",
    icon: "https://bhres.39bh.com/promote_zs_static/open_s.png",
    url: "/home/open_serve",
    id: 4,
    show: false
  },
  {
    name: "礼包查询",
    icon: "https://bhres.39bh.com/promote_zs_static/gift_bag.png",
    url: "/home/gift_search",
    id: 18,
    show: false
  }, {
    name: "钓鱼查询",
    icon: "https://bhres.39bh.com/promote_zs_static/yu_s.png",
    url: "/home/fish_search",
    id: 1,
    show: false
  },
  {
    name: "归属查询",
    icon: "https://bhres.39bh.com/promote_zs_static/g_search.png",
    url: "/home/sense_search",
    id: 2,
    show: false
  },



]

export const sysList = [{
    name: "会长代充",
    icon: "https://bhres.39bh.com/promote_zs_static/daic.png",
    url: "/home/substitute",
    id: 39,
    show: false
  },
  {
    name: "缴纳押金",
    icon: "https://bhres.39bh.com/promote_zs_static/cash.png",
    url: "/mine/charge_deposit",
    id: 10,
    show: false
  },

  {
    name: "代充记录",
    icon: "https://bhres.39bh.com/promote_zs_static/d_recored.png",
    url: "/home/substitute_recored",
    id: 13,
    show: false
  },
  {
    name: "平台币充值",
    icon: "https://bhres.39bh.com/promote_zs_static/plat_charge.png",
    url: "/mine/charge_plat",
    id: 8,
    show: false
  },
  {
    name: "平台币转移",
    icon: "https://bhres.39bh.com/promote_zs_static/plat_move.png",
    url: "/mine/plat_move",
    id: 9,
    show: false
  },

  // {
  //   name: '佣金寄售',
  //   icon: 'https://bhres.39bh.com/promote_zs_static/sell_img.png',
  //   url: '/mine/sell',
  //   id: 27,
  //   show: false
  // },
  {
    name: "冰火币/星币回收记录",
    icon: 'https://bhres.39bh.com/promote_zs_static/bh_back_rec.png',
    url: "/home/bhx_recored",
    id: 36,
    show: false
  }
]
export const dataList = [{
    name: "玩家列表",
    icon: "https://bhres.39bh.com/promote_zs_static/per_list.png",
    url: "/home/user_list",
    id: 11,
    show: false
  },

  {
    name: "登陆记录",
    icon: 'https://bhres.39bh.com/promote_zs_static/user_login_record.png',
    url: "/home/user_recored",
    id: 25,
    show: false
  },
  {
    name: "玩家充值",
    icon: "https://bhres.39bh.com/promote_zs_static/zhic.png",
    url: "/home/recharge_list",
    id: 12,
    show: false
  },

  {
    name: "佣金明细",
    icon: "https://bhres.39bh.com/promote_zs_static/yong_detail.png",
    url: "/mine/commission_detail?type=commission",
    id: 14,
    show: false
  },

  {
    name: "押金明细",
    icon: "https://bhres.39bh.com/promote_zs_static/cash_edit.png",
    url: "/mine/commission_detail?type=deposit",
    id: 16,
    show: false
  },
  {
    name: "积分明细",
    icon: "https://bhres.39bh.com/promote_zs_static/point_detail.png",
    url: "/mine/commission_detail?type=point",
    id: 17,
    show: false
  },


  // {
  //   name: '寄售记录',
  //   icon: 'https://bhres.39bh.com/promote_zs_static/sell_recored.png',
  //   url: '/mine/sell_list',
  //   id: 26,
  //   show: false
  // },
  {
    name: "留存分析",
    icon: "https://bhres.39bh.com/promote_zs_static/liu_xi.png",
    url: "/home/analyse",
    id: 32,
    show: false
  },

  {
    name: "充值排行",
    icon: "https://bhres.39bh.com/promote_zs_static/chong_top.png",
    url: "/home/recharge_top",
    id: 35,
    show: false
  },

  {
    name: "数据汇总",
    icon: "https://bhres.39bh.com/promote_zs_static/datas.png",
    url: "/home/data_total",
    id: 38,
    show: false
  },
  {
    name: "0.1折排行",
    icon: "https://bhres.39bh.com/promote_zs_static/bu_recored.png",
    url: "/home/charge_top",
    id: 33,
    show: false
  },
  {
    name: '非0.1排名',
    icon: "https://bhres.39bh.com/promote_zs_static/bu_recored.png",
    // path: 'datas',
    url: '/home/datas',
    id: 40,
    show: false
  },
  {
    name: "平台币明细",
    icon: "https://bhres.39bh.com/promote_zs_static/plat_detail.png",
    url: "/mine/commission_detail?type=plat",
    id: 15,
    show: false
  },
  // {
  //   name: "小游戏报表",
  //   icon: "https://bhres.39bh.com/promote_zs_static/game_forms.png",
  //   url: "/home/game_statement",
  //   id: 37,
  //   show: false
  // },
  {
    name: "0.1折充值明细",
    icon: "https://bhres.39bh.com/promote_zs_static/charge.png",
    url: "/home/recharge_list?type=0.1",
    id: 24,
    show: false
  },
]
export const cashList = [{
    name: "余额提现",
    icon: "https://bhres.39bh.com/promote_zs_static/commission_t.png",
    url: "/mine/cash",
    id: 7,
    show: false
  },
  {
    name: "余额发布列表",
    icon: "https://bhres.39bh.com/promote_zs_static/commission_detail.png",
    url: "/mine/sum_list",
    id: 29,
    show: false
  },
  {
    name: "余额购买记录",
    icon: "https://bhres.39bh.com/promote_zs_static/yu_buy_rec.png",
    url: "/mine/money_buy_record",
    id: 30,
    show: false
  },
]



// WEBPACK FOOTER //
// ./src/utils/menu.js